import { LoggerService } from '../logger/logger.service';
import { configProvider } from '../config/config.provider';
import { Env } from '../environment';
import { sessionApiService } from '../../dal/session/api.service';

const getLogzioRum = async () => import(/* webpackIgnore: true */ '@logzio/browser');

const isRumAllowed = async (): Promise<boolean> => {
  const isAccountDisabled = await getIsAccountDisabled();

  return !isAccountDisabled && !!Env.configs.rum;
};

const getIsAccountDisabled = async (): Promise<boolean> => {
  const isDisabled = (await sessionApiService.get())?.integrations?.rum?.isDisabled;

  return isDisabled ?? false;
};

const startSession = async (): Promise<void> => {
  try {
    if (!(await isRumAllowed())) return;

    const rumConfig = await configProvider.getValue('rum');

    if (!rumConfig?.region || !rumConfig?.tracesToken) return;

    const { LogzioRUM } = await getLogzioRum();

    LogzioRUM.init({
      region: rumConfig.region,
      tokens: {
        traces: rumConfig.tracesToken,
        logs: rumConfig.logsToken,
      },
      endpoint: { url: rumConfig.endpointUrl },
      service: {
        name: rumConfig.serviceName,
        version: rumConfig.serviceVersion,
      },
    });
  } catch (error) {
    await LoggerService.logError({
      message: `Could not init RUM - ${error?.message}`,
      error,
    });
  }
};

export const rumService = {
  startSession,
};
